import {NameId} from '@drl/core/models';
import {RoleType} from '@drl/core/enums';

export class Role extends NameId {
  permissions: string[] = [];
  roleType: RoleType;
  nameKey?:string;
}
